// tslint:disable:max-line-length
import nvSharedServicesModule from '../shared/services/nv.shared.services.module';
import nvSorterColumnModule from '../shared/sorter-column/nv.sorterColumn.module';
import { StudentCreditGapsPanelCourseHistoryModule } from './stateless-components/panels/student-credit-gaps-panel/student-credit-gaps-panel-course-history/student-credit-gaps-panel-course-history.module';
import { studentCreditGapsPanelCurrentProgramComponent } from './stateless-components/panels/student-credit-gaps-panel/student-credit-gaps-panel-current-program/student-credit-gaps-panel-current-program.component';
import { StudentCreditGapsPanelProgressModule } from './stateless-components/panels/student-credit-gaps-panel/student-credit-gaps-panel-progress/student-credit-gaps-panel-progress.module';
import { studentCreditGapsPanelComponent } from './stateless-components/panels/student-credit-gaps-panel/student-credit-gaps-panel.component';

export default angular
  .module('nv.singleStudent', [
    nvSharedServicesModule,
    'ui.router',
    'SdcFluxModule',
    'nv.shared.error-handling',
    'nv.shared.modals',
    'nv.shared.background-job-ui',
    nvSorterColumnModule,
    StudentCreditGapsPanelProgressModule, // TODO: move to student-credit-gaps-panel module when files are changed to typescript
    StudentCreditGapsPanelCourseHistoryModule, // TODO: move to student-credit-gaps-panel module when files are changed to typescript
  ])
  .component('studentCreditGapsPanelNew', studentCreditGapsPanelComponent)
  .component('studentCreditGapsPanelCurrentProgram', studentCreditGapsPanelCurrentProgramComponent).name;
